import { render, staticRenderFns } from "./RectangularTrapezoidVertical.vue?vue&type=template&id=4942322c&scoped=true&"
import script from "./RectangularTrapezoidVertical.vue?vue&type=script&lang=js&"
export * from "./RectangularTrapezoidVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942322c",
  null
  
)

export default component.exports